export const CHECK_APPOINTMENT_REQUEST = "CHECK_APPOINTMENT_REQUEST";
export const CHECK_APPOINTMENT_SUCCESS = "CHECK_APPOINTMENT_SUCCESS";
export const CHECK_APPOINTMENT_FAIL = "CHECK_APPOINTMENT_FAIL";
export const CHECK_APPOINTMENT_RESET = "CHECK_APPOINTMENT_RESET";